import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  copyPrePortLastMilePrice, editPrePortLastMilePriceStatus,
  queryPrePortLastMilePrice
} from '@/api/price/pricePrePortLastMile'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import moment from 'moment/moment'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getPostalCodeList } from '@/api/basicData/postalCode'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { PRICE_STATUS_NORMAL } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  methods: {
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },

    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
      this.detail()
    },

    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      if (this.source === 'priceLook') {
        this.filter.status = SystemConstants.PRICE_STATUS_NORMAL.code
      }
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      queryPrePortLastMilePrice(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRow = null
        this.selectedRows = []
      }).finally(() => {
        this.loading.close()
      })
    },

    detail() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.pricePrePortLastMileDetail.originForm = this.selectedRow
        this.$refs.pricePrePortLastMileDetail.form = this.selectedRow
      })
    },

    edit() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.pricePrePortLastMileDetail.isEdit = true
        this.$refs.pricePrePortLastMileDetail.originForm = this.selectedRow
        this.$refs.pricePrePortLastMileDetail.form = deepClone(this.selectedRow)
      })
    },

    back() {
      this.view = 'list'
      this.queryHandler()
    },

    copy() {
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      copyPrePortLastMilePrice({ uuid: this.selectedRow.uuid }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    add() {
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.pricePrePortLastMileDetail.isEdit = true
      })
    },

    // 上架
    shelving() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      let row = this.selectedRows.find(row => row.status === SystemConstants.PRICE_STATUS_NORMAL.code)
      if (row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectNonNormalRateForShelving'))
        return
      }
      const now = moment().format('YYYY-MM-DD') + ' 00:00:00'
      row = this.selectedRows.find(row => !(row.beginDate <= now && row.endDate >= now))
      if (row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectValidRateForShelving'))
        return
      }
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      editPrePortLastMilePriceStatus({
        pricePrePortLastMileUuids: this.selectedRows.map(p => p.uuid),
        action: SystemConstants.PRICE_ACTION_LISTED.code
      }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    // 下架
    unShelving() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const row = this.selectedRows.find(row => row.status !== SystemConstants.PRICE_STATUS_NORMAL.code)
      if (row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectNormalRateForUnShelving'))
        return
      }
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      editPrePortLastMilePriceStatus({
        pricePrePortLastMileUuids: this.selectedRows.map(p => p.uuid),
        action: SystemConstants.PRICE_ACTION_UNLISTED.code
      }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    init() {
      if (this.view === 'list') {
        this.queryHandler()
      }
    },
    // 港前运价
    async getPreCustomSearchItems() {
      const defaultSearchFields = []
      // 箱型箱量
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
      searchField.itemName = 'prcPrePortLastMile.EQ_TYPE_SIZE'
      searchField.itemLabel = 'CargoMsg.Cargo_CartonQuantity'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.dataProvider = SystemConstants.SEA_EQ_TYPES_SEARCH
      defaultSearchFields.push(searchField.formatObj2Json())

      // 状态（source 是 priceInput-运价输入）
      if (this.source === 'priceInput') {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'prcPrePortLastMile.STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_Status'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.multiple = 1
        searchField.dataProvider = SystemConstants.PRICE_STATUS
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      return defaultSearchFields
    },
    // 尾程运价
    async getLastCustomSearchItems() {
      const defaultSearchFields = []

      // 配送地址类型
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
      searchField.itemName = 'priceRegion.DELIVERY_ADDRESS_TYPE'
      searchField.itemLabel = 'CargoMsg.Cargo_DeliveryAddressType'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.dataProvider = SystemConstants.DELIVERY_ADDRESS_TYPES
      defaultSearchFields.push(searchField.formatObj2Json())

      // 邮编
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'postCode'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
      searchField.itemName = 'priceRegion.POSTAL_CODE'
      searchField.itemLabel = 'SeaExport.ZIP'
      searchField.tagValue = 'uuid'
      searchField.tagName = 'code'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_SystemConstants$POSTAL_CODES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 仓库代码
      const overseaWarehouses = getCacheListByKey(basicCacheKeys.basic_data_OverseaWarehouse)
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
      searchField.itemName = 'priceRegion.WAREHOUSE_CODE'
      searchField.itemLabel = 'CargoMsg.Cargo_WarehouseCode2'
      searchField.tagValue = 'warehouseCode'
      searchField.tagName = 'warehouseCode'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.dataProvider = overseaWarehouses.filter(p => p.ifFba)
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'basic_data_OverseaWarehouse'
      defaultSearchFields.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
      searchField.itemName = 'prcPrePortLastMile.EQ_TYPE_SIZE'
      searchField.itemLabel = 'CargoMsg.Cargo_CartonQuantity'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.dataProvider = SystemConstants.SEA_EQ_TYPES_SEARCH
      defaultSearchFields.push(searchField.formatObj2Json())

      // 状态（source 是 priceInput-运价输入）
      if (this.source === 'priceInput') {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'prcPrePortLastMile.STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_Status'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.multiple = 1
        searchField.dataProvider = SystemConstants.PRICE_STATUS
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      return defaultSearchFields
    }
  }
}
